import axios from "axios";
import { loadConfig } from './config';

const api = axios.create({
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Set up Axios interceptors to attach authentication token
api.interceptors.request.use(async (config) => {
  const appConfig = await loadConfig();
  //console.log(appConfig);
  //console.log(config.url);

  // If the request URL is relative, prepend the base URL
  if (!config.url.startsWith('http') && appConfig.apiBaseUrl) {
    config.url = `${appConfig.apiBaseUrl}${config.url}`;
  }

  return config;
});

export default api;
